/*
 *
 * Absence constants
 *
 */

// LOAD List
export const LOAD_ABSENCES = 'app/Absence/LOAD_ABSENCES';
export const LOAD_ABSENCES_SUCCESS = 'app/Absence/LOAD_ABSENCES_SUCCESS';
export const LOAD_ABSENCES_ERROR = 'app/Absence/LOAD_ABSENCES_ERROR';

// CHANGE UPDATE
export const CHANGE_ABSENCE = 'app/Absence/CHANGE_ABSENCE';
export const CHANGE_ABSENCE_SUCCESS = 'app/Absence/CHANGE_ABSENCE_SUCCESS';
export const CHANGE_ABSENCE_ERROR = 'app/Absence/CHANGE_ABSENCE_ERROR';

// CHANGE UPDATE LIST
export const CHANGE_ABSENCES = 'app/Absence/CHANGE_ABSENCES';
export const CHANGE_ABSENCES_SUCCESS = 'app/Absence/CHANGE_ABSENCES_SUCCESS';
export const CHANGE_ABSENCES_ERROR = 'app/Absence/CHANGE_ABSENCES_ERROR';

// DELETE
export const DELETE_ABSENCE = 'app/Absence/DELETE_ABSENCE';
export const DELETE_ABSENCE_SUCCESS = 'app/Absence/DELETE_ABSENCE_SUCCESS';
export const DELETE_ABSENCE_ERROR = 'app/Absence/DELETE_ABSENCE_ERROR';

export const FLUSH_STATE_ABSENCE = 'app/Absence/FLUSH_STATE_ABSENCE';

// absence house
// Absence House
// ABSENCE HOUSE
